import request from '@/helpers/request'

export default {
  async index(data) {
    return await request.get('zoom_schedule', data)
  },
  async show(scheduleId) {
    return await request.get('zoom_schedule/' + scheduleId)
  },
  async zoom() {
    return await request.get('zoom_first')
  },
  async classToday() {
    return await request.get('class-today')
  },
  async zoomSetting() {
    return await request.get('zoom_settings')
  }
}

